import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/node_modules/.pnpm/next-intl@4.8.3_next@15.5.12_patch_hash=d565689395e00d268abee561b4a37e98174acd21796bca0_cc98106fafca2cb648283995d12a96ce/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/frontend/node_modules/.pnpm/next@15.5.12_patch_hash=d565689395e00d268abee561b4a37e98174acd21796bca07cec95517e436fd0_8902ccab5f14b4211bb479f76898837b/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["UserJourneyTracker"] */ "/app/frontend/src/components/analytics/UserJourneyTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginModalHost"] */ "/app/frontend/src/components/auth/LoginModalHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthGuard"] */ "/app/frontend/src/components/AuthGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientTranslationCatalog"] */ "/app/frontend/src/components/common/ClientTranslationCatalog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SystemDialogHost"] */ "/app/frontend/src/components/common/SystemDialogHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/frontend/src/components/common/Toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionChecker"] */ "/app/frontend/src/components/common/VersionChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CreditsBalanceSync"] */ "/app/frontend/src/components/credits/CreditsBalanceSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WelcomeRewardHost"] */ "/app/frontend/src/components/credits/WelcomeReward.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevErrorTracker"] */ "/app/frontend/src/components/DevErrorTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebMarketingAttributionCapture"] */ "/app/frontend/src/components/marketing/WebMarketingAttributionCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingGate"] */ "/app/frontend/src/components/onboarding/OnboardingGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralClaimRuntime"] */ "/app/frontend/src/components/referrals/ReferralClaimRuntime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/app/frontend/src/components/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialAttributionCapture"] */ "/app/frontend/src/components/social-publishing/SocialAttributionCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SoulSaveRuntime"] */ "/app/frontend/src/components/subject-model/SoulSaveRuntime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentReturnRedirector"] */ "/app/frontend/src/components/subscription/PaymentReturnRedirector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PurchaseRouteRedirector"] */ "/app/frontend/src/components/subscription/PurchaseRouteRedirector.tsx");
